export const mapUsersByEmailResultEnum = Object.freeze({
    SUCCESS: "success",
    WARNING: "warning",
    NONE: "none"
});


// WEBPACK FOOTER //
// ./src/store/modules/usersMapping/enums/mapUsersByEmailResultEnum.js